"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Text = _interopRequireDefault(require("../../Text"));

var _Box = _interopRequireDefault(require("../../Box"));

var _SubheaderSt = require("./Subheader.st.css");

var _StringUtils = require("../../utils/StringUtils");

var _jsxFileName = "/home/builduser/work/31dad9578a4e06bb/packages/wix-style-react/dist/cjs/Card/Subheader/Subheader.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Subheader = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Subheader, _React$PureComponent);

  var _super = _createSuper(Subheader);

  function Subheader() {
    (0, _classCallCheck2["default"])(this, Subheader);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Subheader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dataHook = _this$props.dataHook,
          title = _this$props.title,
          suffix = _this$props.suffix,
          skin = _this$props.skin;
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-hook": dataHook,
        className: (0, _SubheaderSt.st)(_SubheaderSt.classes.root, {
          skin: skin
        }),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 33,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
        verticalAlign: "middle",
        flexGrow: 1,
        overflow: "hidden",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 39,
          columnNumber: 9
        }
      }, (0, _StringUtils.isString)(title) ? /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        ellipsis: true,
        weight: "normal",
        size: "medium",
        dataHook: "title",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 41,
          columnNumber: 13
        }
      }, title) : /*#__PURE__*/_react["default"].createElement("div", {
        "data-hook": "title-node",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 45,
          columnNumber: 13
        }
      }, title)), suffix && /*#__PURE__*/_react["default"].createElement("div", {
        className: _SubheaderSt.classes.suffix,
        "data-hook": "suffix-node",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 50,
          columnNumber: 11
        }
      }, suffix));
    }
  }]);
  return Subheader;
}(_react["default"].PureComponent);

(0, _defineProperty2["default"])(Subheader, "displayName", 'Card.Subheader');
(0, _defineProperty2["default"])(Subheader, "defaultProps", {
  skin: 'standard'
});
(0, _defineProperty2["default"])(Subheader, "propTypes", {
  /** Applies a data-hook HTML attribute to be used in the tests */
  dataHook: _propTypes["default"].string,

  /** Sets a title text value. Title can also be overridden to any other component. */
  title: _propTypes["default"].node.isRequired,

  /** Adds an empty container on the right side of a subheader. Commonly used to store action buttons or an info icon. */
  suffix: _propTypes["default"].node,

  /** Controls the background color of a subheader  */
  skin: _propTypes["default"].oneOf(['standard', 'neutral'])
});
var _default = Subheader;
exports["default"] = _default;
//# sourceMappingURL=Subheader.js.map